module.exports = __webpack_public_path__ + "static/media/loginS.e5225efa.svg";